import React, { useEffect, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import './UnsubscribeForm.scss'
import FormsService from 'src/services/FormsService'
import ModalFormResponse from '../components/modals/ModalFormResponse'

const UnsubscribeForm = ({ submitButton = 'Confirm Unsubscribe', emailSubscriber }) => {
  const [formSuccess, setFormSuccess] = useState(false)
  const [inputFields, setInputFields] = useState({
    reason: '',
    tellUs: '',
    email: ''
  })
  const [submitting, setSubmitting] = useState(false)
  const service = {
    forms: new FormsService()
  }


  const modalMessage = <>You can subscribe again by submitting 'Subscribe to Newsletter' below.</>
  const modalTitle = <>{emailSubscriber} successfully unsubscribed <i className="fa fa-check-circle" aria-hidden="true"></i></>

  const finishSubmit = async () => {
    setInputFields({ ...inputFields, email: emailSubscriber })
    if (submitting) {
      setSubmitting(false)
      service.forms.newsletterUnsubscribe(inputFields).then((resp: any) => {
        setFormSuccess(true)
        setSubmitting(false)
        createRoot(document.getElementById('modal-responses')).render(<ModalFormResponse status={true} message={modalMessage} title={modalTitle} />)
        //error api
      }).catch(error => {
        console.log('ERR: ', error)
        setSubmitting(false)
      })
    }
  }

  const handleChange = (e) => {
    setInputFields({ ...inputFields, [e.target.name]: e.target.value })
  }

  const handleSubmit = (event) => {
    setInputFields({ ...inputFields, email: emailSubscriber })
    setSubmitting(true)
    event.preventDefault()
  }

  useEffect(() => {
    finishSubmit()
  }, [submitting])

  return (
    <>
      <div className="unsubscribe-form form-holder" id="js-scroll-anchor">
        <form onSubmit={handleSubmit} id="unsubscribe-form">

          <div className="form-group form-group-inline">
            <label htmlFor="to-many" className="pointer">
              <input
                type="radio"
                id="to-many"
                name="reason"
                value={'I\'m receiving to many emails'}
                onChange={handleChange}
              /> I'm receiving to many emails
            </label>
          </div>
          <div className="form-group form-group-inline">
            <label htmlFor="never-subscribed" className="pointer">
              <input
                type="radio"
                id="never-subscribed"
                name="reason"
                value={'I never subscribed to your email'}
                onChange={handleChange}
              />I never subscribed to your email</label>
          </div>
          <div className="form-group form-group-inline">
            <label htmlFor="dont-like" className="pointer">
              <input
                type="radio"
                id="dont-like"
                name="reason"
                value={'I don\'t like the content of the emails'}
                onChange={handleChange}
              />I don't like the content of the emails</label>
          </div>
          <div className="form-group form-group-inline">
            <label htmlFor="other" className="pointer">
              <input
                type="radio"
                id="other"
                name="reason"
                value={'Other'}
                onChange={handleChange}
              />Other</label>
          </div>
          <div className="form-group">
            <label htmlFor="message">tell us more
              <textarea
                name="tellUs"
                rows={3}
                value={inputFields.tellUs}
                onChange={handleChange}
              ></textarea></label>
          </div>

          <div className="form-group">
            <button type="submit" className="button" disabled={submitting}>
              {submitting ? <div className='spinner'></div> : <>{submitButton} <i className="fa-solid fa-check-circle"></i></>}
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export default UnsubscribeForm